import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_178: DocMigration = {
  maxSchemaVersion: "0.0.178",
  description: "Add Foundation Assembly Height Datums",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "WALL_SETTINGS") {
          if (setting.wallConditions !== undefined) {
            if (setting.wallConditions["INTERIOR_FOUNDATION"] !== undefined) {
              setting.wallConditions["INTERIOR_FURRING"] = setting.wallConditions["INTERIOR_FOUNDATION"];
              delete setting.wallConditions["INTERIOR_FOUNDATION"];
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_178;
